import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Container } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    articles: {
        width:'100%',
        height: '60vh',
        marginTop: '20vh',
    },
}));

const Arcticles = () => {
    const classes = useStyles();

    return (
        <Container>
            <div className={classes.articles}>
                <p>articles</p>
            </div>
        </Container>
    )
}

export default Arcticles;
